<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap mt-3>
      <v-flex xs6 md3 text-xs-center v-for="i in 4" :key="alts[i]">
        <button class="hvr-scale" :class="vistos[i-1]?'bot-check-vis-cen':''" @click="currentText = i, $set(vistos,i-1,true)">
          <img :src="require('../../assets/Modulo 3/diapositiva-2-'+ i +'.png')" :alt="alts[i-1]">
        </button>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 lg8 v-if="text != ''">
        <transition name="custom" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster" mode="out-in">
          <p class="texto1 mt-4" :key="text">
            <span v-html="text"></span>
          </p>
        </transition>
      </v-flex>
    </v-layout>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
      'Modulo 3/AUDIO 02'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "La estimación de las cantidades recuperables asociadas a un proyecto o yacimiento puede calcularse a través de procedimientos analíticos. Para evaluar la incertidumbre relativa de las estimaciones de las cantidades recuperables, puede utilizarse tanto métodos determinísticos como probabilísticos. <span class='instruccion'>Haz clic en los iconos</span>" 
      ],
      alts: [
        "",
        ""
      ],
      vistos: Array(4).fill(false),
      currentText: 0
    }
  },
  computed: {
    text: function() {
      switch (this.currentText){
        case 1: return "La mayoría de los evaluadores continúan utilizando los <strong>métodos determinísticos.</strong>";
        case 2: return "Pocas  agencias gubernamentales o reguladoras permiten la opción de basar los reportes <strong>únicamente en resultados probabilísticos.</>";
        case 3: return "Cada vez más compañías utilizan <strong>la combinación de ambos métodos para mejorar la “completitud”</strong> y la consistencia de las evaluaciones de los proyectos más importantes.";
        case 4: return "Dependiendo de la complejidad del yacimiento, el evaluador puede escoger uno o más métodos de estimación de los recursos.";
        default: return ""
      }
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos) {
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
